<div class="container-fluid">
  <app-steps
    [steps]="steps"
    [stepChange]="onStepChange"
    (stepClick)="clickStep($event)"
  ></app-steps>

  @if (isPeriodoVigente()) {
    <div class="alert alert-info" role="alert">
      <i class="fa fa-info-circle" style="color: rgba(21, 91, 203, 1)"></i>
      <strong>Informação!</strong> Prazo para confirmação de vagas:
      <strong>{{ cicloSelected?.confirmacaoVaga.fimFormatado }} ({{ diasRestantes() }} dias restantes)</strong>
    </div>
  }

  <div class="position-relative">
    <app-card-collapse
      [titulo]="'Informações da Vaga'"
      [isCollapsed]="false"
      [enableCollapse]="false"
      class="w-100 h-100 align-items-center justify-content-center"
    >
      <hr />
      <div class="row info-container">
        <div class="col-3">
          <div>Ciclo do Edital</div>
          <span>{{
            cicloSelected
              ? ('00' + cicloSelected.numeroCiclo).slice(-3) + '/' + cicloSelected.anoCiclo
              : '-'
          }}</span>
        </div>
        <div class="col-3">
          <div>Programa</div>
          <span>{{ cicloSelected?.programa?.nome || '-' }}</span>
        </div>
        <div class="col-3">
          <div>Gestor Responsável</div>
          <span>{{ confirmacaoVaga?.usuario?.nome || usuario.nome || '-' }}</span>
        </div>
        <div class="col-3">
          <div>Nível da Vaga</div>
          <span>Municipal</span>
        </div>
        <div class="col-3 mt-4">
          <div>UF</div>
          <span>{{ municipio?.siglaUf || '-' }}</span>
        </div>
        <div class="col-3 mt-4">
          <div>Município</div>
          <span>{{ municipio?.nomeMunicipio || '-' }}</span>
        </div>
        <div class="col-3 mt-4">
          <div>Prazo de Confirmação</div>
          <span>{{ cicloSelected?.confirmacaoVaga?.fimFormatado || '-' }}</span>
        </div>
        <div class="col-3 mt-4">
          <div>IBGE</div>
          <span>{{ municipio?.id || '-' }}</span>
        </div>
      </div>
    </app-card-collapse>
  </div>

  <form [formGroup]="form" novalidate>
    <div class="mt-4">
      @if (currentStep === 1) {
        <app-confirmar-quantidade-vagas-step
          [onConfirmarQuantidades]="onConfirmarQuantidades"
          [onCancel]="onCancel"
          [onSubmitting]="onSubmitting"
          [onModalidadeVagas]="onLoadModalidadeVagas"
          [onPrintCadastroReserva]="onPrintCadastroReserva"
          [form]="formConfirmarQuantidadeVaga"
          [confirmacaoVaga]="confirmacaoVaga"
          [cicloSelected]="cicloSelected"
          [hasCadastroReserva]="hasCadastroReserva"
          [isVagasLoaded]="isVagasLoaded"
        ></app-confirmar-quantidade-vagas-step>
      }
      @if (currentStep === 2) {
        <app-atribuir-ine-step
          [onAtribuirINE]="onAtribuirINE"
          [onStepChange]="onStepChange"
          [onSubmitting]="onSubmitting"
          [cicloSelected]="cicloSelected"
          [confirmacaoVaga]="confirmacaoVaga"
          [form]="formAtribuirINE"
        ></app-atribuir-ine-step>
      }
      @if (currentStep === 3) {
        <app-resumo-confirmacao-step
          [onResumoConfirmacao]="onResumoConfirmacao"
          [onStepChange]="onStepChange"
          [onSubmitting]="onSubmitting"
          [cicloSelected]="cicloSelected"
          [confirmacaoVaga]="confirmacaoVaga"
        ></app-resumo-confirmacao-step>
      }
    </div>
  </form>
</div>
